import clsx from 'clsx'

const DashboardCard = ({ children, className, ...props }) => {
  return (
    <div
      className={clsx(
        'bg-surface border border-border shadow-card rounded-card p-4 sm:p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default DashboardCard
